// -----------------------------------------------------------
// FloraIQ — Aba Inconsistências
// -----------------------------------------------------------

import { useState } from "react";
import { useQualityIssuesList } from "@/hooks";
import { SeverityBadge, ValidationStatusBadge } from "./QualityStatusBadge";
import InconsistencyDetailDrawer from "./InconsistencyDetailDrawer";

export default function InconsistenciesTable() {
  const [search, setSearch] = useState("");
  const [filterSeverity, setFilterSeverity] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { items: allInconsistencies } = useQualityIssuesList();

  const filtered = allInconsistencies.filter((inc) => {
    if (search && !inc.codigoCta.toLowerCase().includes(search.toLowerCase()) && !inc.descricao.toLowerCase().includes(search.toLowerCase()) && !inc.projeto.toLowerCase().includes(search.toLowerCase())) return false;
    if (filterSeverity && inc.severidade !== filterSeverity) return false;
    if (filterStatus && inc.status !== filterStatus) return false;
    return true;
  });

  return (
    <div className="space-y-4">
      {/* Filtros */}
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          <input
            type="text"
            placeholder="Buscar por código CTA, projeto, regra ou descrição..."
            className="w-full border border-background-200/70 rounded-md pl-9 pr-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <select
          className="border border-background-200/70 rounded-md px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
          value={filterSeverity}
          onChange={(e) => setFilterSeverity(e.target.value)}
        >
          <option value="">Todas severidades</option>
          <option value="crítica">Crítica</option>
          <option value="alta">Alta</option>
          <option value="média">Média</option>
          <option value="baixa">Baixa</option>
        </select>
        <select
          className="border border-background-200/70 rounded-md px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
        >
          <option value="">Todos os status</option>
          <option value="pendente">Pendente</option>
          <option value="em_analise">Em Análise</option>
          <option value="corrigida">Corrigida</option>
        </select>
      </div>

      <p className="text-xs text-foreground-500">{filtered.length} inconsistências encontradas</p>

      {/* Tabela */}
      <div className="overflow-x-auto border border-background-200/70 rounded-card">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-background-50 border-b border-background-200/70">
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap w-10"></th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Regra</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">CTA / Unidade</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Projeto</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Descrição</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Responsável</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Detectada em</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Status</th>
              <th className="text-center px-3 py-2.5 font-medium text-foreground-600 whitespace-nowrap">Ações</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((inc) => (
              <tr key={inc.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-3 py-2.5"><SeverityBadge severity={inc.severidade} /></td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[180px] truncate">{inc.regra}</td>
                <td className="px-3 py-2.5 font-mono text-foreground-700">{inc.codigoCta}</td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[140px] truncate">{inc.projeto}</td>
                <td className="px-3 py-2.5 text-foreground-700 max-w-[240px] truncate">{inc.descricao}</td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[120px] truncate">{inc.responsavel}</td>
                <td className="px-3 py-2.5 text-foreground-500 whitespace-nowrap">{inc.detectadaEm}</td>
                <td className="px-3 py-2.5"><ValidationStatusBadge status={inc.status} /></td>
                <td className="px-3 py-2.5 text-center">
                  <div className="flex items-center justify-center gap-1">
                    <button onClick={() => setDrawerOpen(true)} className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer" title="Abrir detalhe">
                      <i className="ri-eye-line text-foreground-500 text-sm"></i>
                    </button>
                    <button className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer" title="Corrigir">
                      <i className="ri-tools-line text-foreground-500 text-sm"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <InconsistencyDetailDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </div>
  );
}